/// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/// Writing to Local Storage - Browser Storage
/// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const useGetLocalStorage = (storageValue: string) => {
  if (import.meta.client) {
    return localStorage.getItem(storageValue)
  }
  return
}

export const useSetLocalStorage = (key: string, storageValue: string) => {
  if (import.meta.client) {
    localStorage.setItem(key, storageValue)
    return { key, value: storageValue }
  }
  return
}

export const useRemoveLocalStorage = (key: string) => {
  if (import.meta.client) {
    localStorage.removeItem(key)
    return { key }
  }
  return
}